import { timestamp } from '@/utils/date';
import { userDevice } from '@/utils/system';

export const formatAudioFileName = (userid, sessionid,  key) =>
  `${userid}/${sessionid}/${timestamp()}-device_${userDevice()}-${key}.wav`;
